<template>
  <a-config-provider :locale="antdLocale">
  <div :class="[multipage === true ? 'multi-page':'single-page', 'not-menu-page', 'home-page']">
    <a-row :gutter="8" class="head-info" v-if="user.companyCode != '10000'">
<!--      可提现金额-->
<!--      <a-card class="head-info-card">-->
<!--        <a-col :span="12">-->
<!--          <div class="head-info-avatar">-->
<!--            <p>{{ $t('homepage.canWithdrawalIncome') }}：</p>-->
<!--            <div class="j_number juyeloow">¥{{availableBalance}}</div>-->
<!--          </div>-->
<!--          <div class="head-info-count" style="margin-top: 25px;">-->
<!--            <a-button type="primary" v-hasPermission="['withdrawal:apply']" @click="tixian">{{$t('homepage.withdraw')}}</a-button>-->
<!--          </div>-->
<!--        </a-col>-->
<!--      </a-card>-->
      <a-card class="head-info-card ju_hide">
        <a-col :span="12">
          <div class="head-info-avatar">
            <img :alt="$t('homepage.avatarAlt')" :src="avatar">
          </div>
          <div class="head-info-count">
            <div class="head-info-welcome">
              {{welcomeMessage}}
            </div>
            <div class="head-info-desc">
              <p>{{user.deptName ? user.deptName : $t('homepage.noDept')}} | {{user.roleName ? user.roleName : $t('homepage.noRole')}}</p>
            </div>
            <div class="head-info-time">{{ $t('homepage.lastLoginTime') }}：{{user.lastLoginTime ? user.lastLoginTime : $t('homepage.firstVisit')}}</div>
          </div>
        </a-col>
        <a-col :span="12">
          <div>
            <a-row class="more-info">
              <a-col :span="4"></a-col>
              <a-col :span="4"></a-col>
              <a-col :span="4"></a-col>
              <a-col :span="4">
                <head-info :title="$t('homepage.todayIp')" :content="todayIp" :center="false" :bordered="false"/>
              </a-col>
              <a-col :span="4">
                <head-info :title="$t('homepage.todayVisit')" :content="todayVisitCount" :center="false" :bordered="false"/>
              </a-col>
              <a-col :span="4">
                <head-info :title="$t('homepage.totalVisit')" :content="totalVisitCount" :center="false" />
              </a-col>
            </a-row>
          </div>
        </a-col>
      </a-card>
    </a-row>
    <div style="padding: 8px 0; display: flex; align-items: center; justify-content: flex-end;">
      <span style="margin-right: 8px; font-size: 14px; color: #333;">{{ $t('homepage.dateQuery') }}：</span>
      <a-date-picker
        v-model="selectedDate"
        :placeholder="$t('homepage.selectDate')"
        format="YYYY-MM-DD"
        :allow-clear="true"
        @change="onDateChange"
        style="width: 200px;"
      />
      <a-button v-if="selectedDate" @click="backToToday" style="margin-left: 8px;">{{ $t('homepage.today') }}</a-button>
    </div>
     <a-row :gutter='8' class="count-info z-row" justify="space-between" >


      <a-col :span="6" class="visit-count-wrapper">
        <a-card class="visit-count j_box j_box_h">
          <span class="iconfont icontest juyeloow"></span>
          <p>{{ $t('homepage.todayfc') }}</p>
          <div class="j_number juyeloow">{{ currency }}{{dayStatistics.amount}}</div>
          <div class="j_ms">
            <span>{{ $t('homepage.weekQOQ') }}
              <span class="green" v-if="weekStatistics && weekStatistics.amount > 0">↑</span>
              <span class="green" v-if="weekStatistics && weekStatistics.amount == 0"></span>
              <span class="red" v-if="weekStatistics && weekStatistics.amount < 0">↓</span>
              {{weekStatistics ? Math.abs(weekStatistics.amount) : 0}}%
              </span>
            <span> {{ $t('homepage.dayQOQ') }}
              <span class="green" v-if="dayChainStatistics.amount > 0">↑</span>
              <span class="green" v-if="dayChainStatistics.amount == 0"></span>
              <span class="red" v-if="dayChainStatistics.amount < 0">↓</span>
              {{dayChainStatistics.amount ? Math.abs(dayChainStatistics.amount) : 0}}%  </span>
          </div>
        </a-card>
      </a-col>

      <a-col :span="6" class="visit-count-wrapper" v-if="user.companyCode == '10000'">
        <a-card class="visit-count j_box j_box_h">
          <span class="iconfont icontest juyeloow"></span>
          <p>{{ $t('homepage.todayCompanyIncome') }}</p>
          <div class="j_number juyeloow">{{ currency }}{{amountStatistics.dayCompanySumAmount}}</div>
          <div class="j_ms">
            <span>{{ $t('homepage.weekQOQ') }}
              <span class="green" v-if="amountStatistics && amountStatistics.weekCompanyYearOnYear > 0">↑</span>
              <span class="green" v-if="amountStatistics && amountStatistics.weekCompanyYearOnYear == 0"></span>
              <span class="red" v-if="amountStatistics && amountStatistics.weekCompanyYearOnYear < 0">↓</span>
              {{amountStatistics ? Math.abs(amountStatistics.weekCompanyYearOnYear) : 0}}%
              </span>
            <span>{{ $t('homepage.dayQOQ') }}
              <span class="green" v-if="amountStatistics.dayCompanyChain > 0">↑</span>
              <span class="green" v-if="amountStatistics.dayCompanyChain == 0"></span>
              <span class="red" v-if="amountStatistics.dayCompanyChain < 0">↓</span>
              {{amountStatistics.companySumAmount ? Math.abs(amountStatistics.dayCompanyChain) : 0}}%  </span>
          </div>
        </a-card>
      </a-col>

      <a-col :span="6" class="visit-count-wrapper" v-if="user.companyCode == '10000'">
        <a-card class="visit-count j_box j_box_h">
          <span class="iconfont icontest juyeloow"></span>
          <p>{{ $t('homepage.todayPlatformIncome') }}</p>
          <div class="j_number juyeloow">{{ currency }}{{amountStatistics.daySumAmount}}</div>
          <div class="j_ms">
            <span>{{ $t('homepage.weekQOQ') }}
              <span class="green" v-if="amountStatistics && amountStatistics.weekSumYearOnYear > 0">↑</span>
              <span class="green" v-if="amountStatistics && amountStatistics.weekSumYearOnYear == 0"></span>
              <span class="red" v-if="amountStatistics && amountStatistics.weekSumYearOnYear < 0">↓</span>
              {{amountStatistics ? Math.abs(amountStatistics.weekSumYearOnYear) : 0}}%
              </span>
            <span>{{ $t('homepage.dayQOQ') }}
              <span class="green" v-if="amountStatistics.daySumChain > 0">↑</span>
              <span class="green" v-if="amountStatistics.daySumChain == 0"></span>
              <span class="red" v-if="amountStatistics.daySumChain < 0">↓</span>
              {{amountStatistics.daySumChain ? Math.abs(amountStatistics.daySumChain): 0}}%  </span>
          </div>
        </a-card>
      </a-col>

      <a-col :span="6" class="visit-count-wrapper">
        <a-card class="visit-count j_box j_box_h" >
          <span class="iconfont iconkeliufenxi dred"></span>
          <p>{{ $t('homepage.todayFlow') }}</p>
          <div class="j_number dred">
            {{dayStatistics.flow}}
          </div>
          <div class="j_ms">
            <span>{{ $t('homepage.weekQOQ') }}
              <span class="green" v-if="weekStatistics && weekStatistics.flow > 0">↑</span>
              <span class="green" v-if="weekStatistics && weekStatistics.flow == 0"></span>
              <span class="red" v-if="weekStatistics && weekStatistics.flow < 0">↓</span>
              {{weekStatistics ? Math.abs(weekStatistics.flow) : 0}}%
              </span>
            <span>{{ $t('homepage.dayQOQ') }}
              <span class="green" v-if="dayChainStatistics.flow > 0">↑</span>
              <span class="green" v-if="dayChainStatistics.flow == 0"></span>
              <span class="red" v-if="dayChainStatistics.flow < 0">↓</span>
              {{dayChainStatistics.flow ? Math.abs(dayChainStatistics.flow) : 0}}%  </span>
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="visit-count-wrapper">
        <a-card class="visit-count j_box j_box_h">
          <span class="iconfont icondingdan j_bule"></span>
          <p>{{ $t('homepage.todayOrder') }}</p>
          <div class="j_number j_bule">
            {{dayStatistics.count}}
          </div>
          <div class="j_ms">
            <span>{{ $t('homepage.weekQOQ') }}
              <span class="green" v-if="weekStatistics && weekStatistics.count > 0">↑</span>
              <span class="green" v-if="weekStatistics && weekStatistics.count == 0"></span>
              <span class="red" v-if="weekStatistics && weekStatistics.count < 0">↓</span>
              {{weekStatistics ? Math.abs(weekStatistics.count) : 0}}%
              </span>
            <span>{{ $t('homepage.dayQOQ') }}
              <span class="green" v-if="dayChainStatistics.count > 0">↑</span>
              <span class="green" v-if="dayChainStatistics.count == 0"></span>
              <span class="red" v-if="dayChainStatistics.count < 0">↓</span>
              {{dayChainStatistics.count ? Math.abs(dayChainStatistics.count) : 0}}%  </span>
          </div>
        </a-card>
      </a-col>

      <a-col :span="6" class="visit-count-wrapper">
        <a-card class="visit-count j_box j_box_h">
          <span class="iconfont icondingdan j_bule"></span>
          <p>{{ $t('homepage.todayRefundOrder') }}</p>
          <div class="j_number j_bule">
            {{dayStatistics.refundCount}}
          </div>
          <div class="j_ms">
            <span>{{ $t('homepage.weekQOQ') }}
              <span class="green" v-if="weekStatistics && weekStatistics.refundCount > 0">↑</span>
              <span class="green" v-if="weekStatistics && weekStatistics.refundCount == 0"></span>
              <span class="red" v-if="weekStatistics && weekStatistics.refundCount < 0">↓</span>
              {{weekStatistics ? Math.abs(weekStatistics.refundCount) : 0}}%
              </span>
            <span>{{ $t('homepage.dayQOQ') }}
              <span class="green" v-if="dayChainStatistics.refundCount > 0">↑</span>
              <span class="green" v-if="dayChainStatistics.refundCount == 0"></span>
              <span class="red" v-if="dayChainStatistics.refundCount < 0">↓</span>
              {{dayChainStatistics.refundCount ? Math.abs(dayChainStatistics.refundCount) : 0}}%  </span>
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="visit-count-wrapper">
        <a-card class="visit-count j_box j_box_h" >
          <!-- <span class="iconfont icondingdan j_bule"></span> -->
          <p>{{ $t('homepage.machineOnlineCount') }}</p>
          <div class="j_number j_bule">
            {{deviceLineStatistics.onlineCount}}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="visit-count-wrapper">
        <a-card class="visit-count j_box j_box_h" >
          <!-- <span class="iconfont icondingdan j_bule"></span> -->
          <p>{{ $t('homepage.machineOfflineCount') }}</p>
          <div class="j_number j_bule">
            {{deviceLineStatistics.offlineCount}}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="visit-count-wrapper" v-if="user.companyCode == '10000'">
        <a-card class="visit-count j_box j_box_h">
          <span class="iconfont icontest juyeloow"></span>
          <p>{{ $t('homepage.totalPlatformIncome') }}</p>
          <div class="j_number juyeloow">
            {{ currency }}{{amountStatistics.sumAmount}}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="visit-count-wrapper" v-if="user.companyCode == '10000'">
        <a-card class="visit-count j_box j_box_h">
          <span class="iconfont icontest juyeloow"></span>
          <p>{{ $t('homepage.totalOperatorIncome') }}</p>
          <div class="j_number juyeloow">
            {{ currency }}{{amountStatistics.justSumAmount}}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="visit-count-wrapper" v-if="user.companyCode == '10000'">
        <a-card class="visit-count j_box j_box_h" >
          <span class="iconfont icontest juyeloow"></span>
          <p>{{ $t('homepage.totalCompanyIncome') }}</p>
          <div class="j_number juyeloow">
            {{ currency }}{{amountStatistics.companySumAmount}}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="visit-count-wrapper">
        <a-card class="visit-count j_box j_box_h" >
          <span class="iconfont iconkeliufenxi dred"></span>
          <p>{{ $t('homepage.totalFlow') }}</p>
          <div class="j_number dred">
            {{allStatistics.flow}}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="visit-count-wrapper">
        <a-card class="visit-count j_box j_box_h" >
          <span class="iconfont icondingdan j_bule"></span>
          <p>{{ $t('homepage.totalOrder') }}</p>
          <div class="j_number j_bule">
            {{allStatistics.count}}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="visit-count-wrapper">
        <a-card class="visit-count j_box j_box_h" >
          <span class="iconfont icondingdan j_bule"></span>
          <p>{{ $t('homepage.totalRefundOrder') }}</p>
          <div class="j_number j_bule">
            {{allStatistics.refundCount}}
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="8" class="count-info">
      <a-col :span="24">
<!--        <a-row>-->
<!--          <h2 class="ju_anbule z_siyouNumb">{{ $t('homepage.usage') }}</h2>-->
<!--        </a-row>-->
        <a-row class="ju_youLian">
          <a-col :span="14">
            <span>{{dateAll}}</span>
          </a-col>
          <a-col :span="10" class="ju_stitle">
            <a-col :span="8">
              <span class="z_bgbox ju_bg_yel"></span>
              {{ $t('homepage.incomeAmount') }}
              </a-col>
            <a-col :span="8">
              <span class="z_bgbox ju_bg_bule"></span>
              {{ $t('homepage.flow') }}
              </a-col>
            <a-col :span="8">
              <span class="z_bgbox ju_bg_zhishe"></span>
              {{ $t('homepage.orderCount') }}
            </a-col>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" class="visit-count-wrapper">
        <a-card class="visit-count" style="">
          <div class="z-row justify-content-around align-items-center tc">
            <div class="z-col-auto z_plr20">
                <h2 class="j_bule tc">{{dayStatistics.count}}</h2>
                <p>
                  <span class="green" v-if="dayChainStatistics.count > 0">↑</span>
                  <span class="green" v-if="dayChainStatistics.count == 0">↑</span>
                  <span class="red" v-if="dayChainStatistics.count < 0">↓</span>
                {{dayChainStatistics.count}}% 丨 {{ $t('homepage.todayOrder') }}</p>
            </div>
            <div class="z-col-auto z_plr20">
                <h2 class="juyeloow tc">{{ currency }}{{dayStatistics.amount}}</h2>
                <p>
                  <span class="green" v-if="dayChainStatistics.amount > 0">↑</span>
                  <span class="green" v-if="dayChainStatistics.amount == 0">↑</span>
                  <span class="red" v-if="dayChainStatistics.amount < 0">↓</span>
                  {{dayChainStatistics.amount}}% 丨 {{ $t('homepage.todayIncome') }}</p>
            </div>
            <div class="z-col-auto z_plr20">
                <h2 class="dred tc">{{dayStatistics.flow}}</h2>
                <p>
                  <span class="green" v-if="dayChainStatistics.flow > 0">↑</span>
                  <span class="green" v-if="dayChainStatistics.flow == 0">↑</span>
                  <span class="red" v-if="dayChainStatistics.flow < 0">↓</span>
                {{dayChainStatistics.flow}}% 丨 {{ $t('homepage.todayFlow') }}</p>
            </div>
          </div>

          <div  id="countChart" ref="countChart" style="height: 400px;border:1px solid  #f1f1f1;border-radius: 5px" ></div>
        </a-card>
      </a-col>
    </a-row>
    <!-- 提现弹窗 -->
  <homepage-info
    :CompanyInfoData="CompanyInfo.data"
    :CompanyInfoVisiable="CompanyInfo.visiable"
    @close="handleUserInfoClose"
    @success="getCancelTixian">
  </homepage-info>
    <!-- 设备相纸不足提醒弹窗 -->
    <a-modal
      v-model="lowPaperVisible"
      :title="$t('homepage.lowPaperTitle')"
      :centered="true"
      :width="680"
      :footer="null">
      <p style="margin-bottom: 12px; color: #FB5694; white-space: normal; word-break: break-word; word-wrap: break-word;">
        {{ $t('homepage.lowPaperTip', {count: lowPaperThreshold}) }}
      </p>
      <a-table
        :columns="lowPaperColumns"
        :data-source="lowPaperDevices"
        :pagination="false"
        row-key="id"
        size="middle">
        <template slot="pagerNum" slot-scope="text">
          <span style="color: red; font-weight: bold;">{{text}}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-button type="primary" size="small" @click="viewLowPaperDevice(record)">{{ $t('common.view') }}</a-button>
        </template>
      </a-table>
      <div style="text-align: right; margin-top: 16px;">
        <a-button @click="lowPaperVisible = false">{{ $t('homepage.lowPaperClose') }}</a-button>
      </div>
    </a-modal>
    <!-- 设备详情 -->
    <device-info
      :deviceInfoData="deviceInfo.data"
      :deviceInfoVisiable="deviceInfo.visiable"
      @close="handleDeviceInfoClose">
    </device-info>
  </div>
  </a-config-provider>
</template>
<script>
// <style scoped>
// @import "../static/fonts/iconfont.css";//自定义.css的样式路径
// </style>
// <link rel="stylesheet" href="static/fonts/iconfont.css">
import HeadInfo from '@/views/common/HeadInfo'
import {mapState} from 'vuex'
import moment from 'moment'
import RunningTask from './common/RunningTask'
import HomepageInfo from './HomePageInfo'
import DeviceInfo from './device/DeviceInfo'

import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
import 'moment/locale/zh-cn'
import 'moment/locale/en-gb'

moment.locale('zh-cn')
export default {
  name: 'HomePage',
  components: {RunningTask, HeadInfo, HomepageInfo, DeviceInfo},
  data () {
    return {
      series: [],
      projects: [],
      todayIp: '',
      todayVisitCount: '',
      totalVisitCount: '',
      userRole: '',
      userDept: '',
      lastLoginTime: '',
      welcomeMessage: '',
      loadRepo: 0,
      htmlspan: '<span style="display:inline-block;margin-right: 5px;border-radius: 10px;width: 10px;height: 10px;background-color: ',
      legends: [this.$t('homepage.todayOrder'), this.$t('homepage.todayIncome'), this.$t('homepage.todayFlow')],
      myChart: {},
      allStatistics: {},
      dayChainStatistics: {},
      dayStatistics: {},
      weekStatistics: {},
      amountStatistics:{},
      sevenDayStatistics: [],
      deviceLineStatistics:{},
      dateAll: '',
      selectedDate: null,
      availableBalance: 0,
      CompanyInfo: {
        visiable: false,
        data: {}
      },
      lowPaperVisible: false,
      lowPaperDevices: [],
      lowPaperThreshold: 50,
      deviceInfo: {
        visiable: false,
        data: {}
      },
    }
  },
  computed: {
    ...mapState({
      multipage: state => state.setting.multipage,
      currency: state => state.setting.currency,
      user: state => state.account.user
    }),
    // 相纸不足提醒表格列（支持语言切换）
    lowPaperColumns () {
      return [
        {title: this.$t('homepage.lowPaperDeviceName'), dataIndex: 'deviceName', key: 'deviceName'},
        {title: this.$t('homepage.lowPaperDeviceCode'), dataIndex: 'activeCode', key: 'activeCode'},
        {title: this.$t('homepage.lowPaperCount'), dataIndex: 'pagerNum', key: 'pagerNum', scopedSlots: {customRender: 'pagerNum'}},
        {title: this.$t('common.operation'), key: 'action', width: 100, scopedSlots: {customRender: 'action'}}
      ]
    },
    // 日期控件支持国际化
    antdLocale() {
      const localeMap = {
        'zh-CN': zhCN,
        'en-US': enUS,
        'th-TH': zhCN, // 泰语暂时使用中文locale
        'vi-VN': zhCN, // 越南语暂时使用中文locale
        'ms-MY': zhCN, // 马来语暂时使用中文locale
        'id-ID': zhCN  // 印尼语暂时使用中文locale
      }
      return localeMap[this.$i18n.locale] || zhCN
    },
    avatar () {
      return `static/avatar/${this.user.avatar}`
    }
  },
  methods: {
    // 初始化 echarts 图表：通过 $refs 取节点并防止重复初始化，避免节点未就绪时 echarts.init(null) 报错
    initChart () {
      if (this.myChart && typeof this.myChart.setOption === 'function') {
        return
      }
      const el = this.$refs.countChart
      if (!el) {
        return
      }
      this.myChart = this.$echarts.init(el)
    },
    getDashboard (targetDate) {
      let that = this
      this.series = []
      let url = targetDate ? 'dashboard/home/byDate?date=' + targetDate : 'dashboard/home'
    this.$get(url).then((r) => {
            //console.log("***在这里***")
            //console.log(r.data.data)
            let data = r.data.data
            this.allStatistics = r.data.data.allStatistics
            this.dayChainStatistics = r.data.data.dayChainStatistics
            this.dayStatistics = r.data.data.dayStatistics
            this.weekStatistics = r.data.data.weekYearOnYear
            this.sevenDayStatistics = r.data.data.sevenDayStatistics
            this.amountStatistics =r.data.data.amountStatistics
            this.deviceLineStatistics =r.data.data.deviceLineStatistics

            //echarts图配置
            let dateArr = []
            let totalSeries = {name: this.$t('homepage.todayIncome'), data: [], type: 'line', smooth: true, itemStyle:{
                color:"#FCA036"
              }
            }
            let yourSeries = {name: this.$t('homepage.todayFlow'), data: [], type: 'line', smooth: true, itemStyle:{
             color:"#FB5694"
            }}
            let OrdersToday ={name: this.$t('homepage.todayOrder'), data: [], type: 'line', smooth: true, itemStyle:{
              color:"#4AA4FF"
            }}
            this.sevenDayStatistics.forEach(function(element) {
              dateArr.push(element.title)
              totalSeries.data.push(element.amount)
              yourSeries.data.push(element.flow)
              OrdersToday.data.push(element.count)
            })
            this.series.push(totalSeries)
            this.series.push(yourSeries)
            this.series.push(OrdersToday)

            // 兜底初始化图表（mounted 时节点可能未就绪），初始化失败则跳过渲染
            this.initChart()
            if (!this.myChart || typeof this.myChart.setOption !== 'function') {
              return
            }
            this.myChart.setOption({
          title: {
            text: this.$t('homepage.usage'),
            show: true,
            left: 10,
            top: 10
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'line'
            },
            formatter: function name (params) {
              let htmlTip = ''
              for (let i = 0; i < params.length; i++) {
                if (i === 0) {
                  htmlTip += params[i].axisValue + '<br />'
                }
                if (i === (params.length - 1)) {
                  htmlTip += (that.htmlspan + params[i].color + ';"></span>' + params[i].seriesName + ' : ' + params[i].value)
                } else {
                  htmlTip += (that.htmlspan + params[i].color + ';"></span>' + params[i].seriesName + ' : ' + params[i].value + '<br />')
                }
              }
              return htmlTip
            }
          },
          legend: {
            type: 'scroll',
            x: 'center',
            y: 'bottom',
            textStyle: {
              fontSize: '12'
            },
            data: this.legends
          },
          toolbox: {
            show: true,
            right: 20,
            top: 10,
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: dateArr,
            axisLabel: {
              textStyle: {
                fontSize: '12'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                fontSize: '12'
              }
            }
          },
          grid: {
            left: '4%'
          },
          series: this.series
        }, true)
      }).catch((r) => {
        console.error(r)
        that.$message.error(this.$t('common.connectionError'))
      })
    },
    welcome () {
      const date = new Date()
      const hour = date.getHours()
      let time = hour < 6 ? this.$t('homepage.goodMorning') : (hour <= 11 ? this.$t('homepage.goodForenoon') : (hour <= 13 ? this.$t('homepage.goodNoon') : (hour <= 18 ? this.$t('homepage.goodAfternoon') : this.$t('homepage.goodEvening'))))
      let welcomeArr = [
        this.$t('homepage.welcome1'),
        this.$t('homepage.welcome2'),
        this.$t('homepage.welcome3'),
        this.$t('homepage.welcome4'),
        this.$t('homepage.welcome5'),
        this.$t('homepage.welcome6'),
        this.$t('homepage.welcome7'),
        this.$t('homepage.welcome8'),
        this.$t('homepage.welcome9'),
        this.$t('homepage.welcome10'),
        this.$t('homepage.welcome11')
      ]
      let index = Math.floor((Math.random() * welcomeArr.length))
      return `${time}，${this.user.username}`
    },
    getRepos () {
      this.$originalGet('https://api.github.com/users/wuyouzhuguli/repos').then((r) => {
        r.data.forEach(repo => {
          let project = {}
          project.id = repo.id
          project.name = repo.name
          project.description = repo.description
          project.avatar = repo.name.substring(0, 1).toUpperCase()
          this.projects.push(project)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    runningProject () {
      let that = this
      this.$get(`index/${this.user.username}`).then((r) => {
        let data = r.data.data
        this.todayIp = data.todayIp
        this.todayVisitCount = data.todayVisitCount
        this.totalVisitCount = data.totalVisitCount
        console.log("******k")
        console.log(data)
        // let dateArr = []
        // let totalSeries = {name: '今日收入额', data: [], type: 'line', smooth: true, itemStyle:{
        //  normlal:{
        //   color:"#FCA036"
        //  }
        // }
        // }
        // let yourSeries = {name: '今日客流量', data: [], type: 'line', smooth: true, itemStyle:{
        //  normlal:{
        //   color:"#FB5694"
        //  }
        // }}
        // let OrdersToday ={name: '今日订单数', data: [], type: 'line', smooth: true, itemStyle:{
        //  normlal:{
        //   color:"#67DAFF"
        //  }
        // }}
        // for (let i = 6; i >= 0; i--) {
        //   let time = moment().subtract(i, 'days').format('MM-DD')
        //   let contain = false
        //   for (let o of data.lastSevenVisitCount) {
        //     if (o.days === time) {
        //       contain = true
        //       totalSeries.data.push(o.count)
        //     }
        //   }
        //   if (!contain) {
        //     totalSeries.data.push(0)
        //   }
        //   dateArr.push(time)
        // }
        // this.series.push(totalSeries)
        // for (let i = 6; i >= 0; i--) {
        //   let time = moment().subtract(i, 'days').format('MM-DD')
        //   let contain = false
        //   for (let o of data.lastSevenUserVisitCount) {
        //     if (o.days === time) {
        //       contain = true
        //       yourSeries.data.push(o.count)
        //     }
        //   }
        //   if (!contain) {
        //     yourSeries.data.push(0)
        //   }
        // }
        // this.series.push(yourSeries)

        // this.myChart.setOption({
        //   title: {
        //     text: '使用量',
        //     show: true,
        //     left: 10,
        //     top: 10
        //   },
        //   tooltip: {
        //     trigger: 'axis',
        //     axisPointer: {
        //       type: 'line'
        //     },
        //     formatter: function name (params) {
        //       let htmlTip = ''
        //       for (let i = 0; i < params.length; i++) {
        //         if (i === 0) {
        //           htmlTip += params[i].axisValue + '<br />'
        //         }
        //         if (i === (params.length - 1)) {
        //           htmlTip += (that.htmlspan + params[i].color + ';"></span>' + params[i].seriesName + ' : ' + params[i].value)
        //         } else {
        //           htmlTip += (that.htmlspan + params[i].color + ';"></span>' + params[i].seriesName + ' : ' + params[i].value + '<br />')
        //         }
        //       }
        //       return htmlTip
        //     }
        //   },
        //   legend: {
        //     type: 'scroll',
        //     x: 'center',
        //     y: 'bottom',
        //     textStyle: {
        //       fontSize: '12'
        //     },
        //     data: this.legends
        //   },
        //   toolbox: {
        //     show: true,
        //     right: 20,
        //     top: 10,
        //     feature: {
        //       saveAsImage: {}
        //     }
        //   },
        //   xAxis: {
        //     type: 'category',
        //     boundaryGap: true,
        //     data: dateArr,
        //     axisLabel: {
        //       textStyle: {
        //         fontSize: '12'
        //       }
        //     }
        //   },
        //   yAxis: {
        //     type: 'value',
        //     axisLabel: {
        //       formatter: '{value}',
        //       textStyle: {
        //         fontSize: '12'
        //       }
        //     }
        //   },
        //   grid: {
        //     left: '4%'
        //   },
        //   series: this.series
        // }, true)
      }).catch((r) => {
        console.error(r)
        that.$message.error('获取首页信息失败')
      })
    },
    onDateChange (date, dateString) {
      if (date) {
        this.getDashboard(dateString)
      } else {
        this.getDashboard()
      }
      this.updateDateDisplay()
    },
    backToToday () {
      this.selectedDate = null
      this.getDashboard()
      this.updateDateDisplay()
    },
    updateDateDisplay () {
      let nowDate = new Date();
      let dateSeven;
      if (this.selectedDate) {
        nowDate = this.selectedDate.toDate();
      }
      dateSeven = new Date(nowDate);
      dateSeven.setDate(nowDate.getDate() - 7);
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      }
      let date2 = {
        year: dateSeven.getFullYear(),
        month: dateSeven.getMonth() + 1,
        date: dateSeven.getDate(),
      }
      this.dateAll = this.$t('homepage.dateRange', {start: `${date2.year}-${date2.month}-${date2.date}`, end: `${date.year}-${date.month}-${date.date}`})
    },
    getCompanyWallet () {
      this.$get('company/wallet').then((r) => {
        this.availableBalance = r.data.data.availableBalance
      })
    },
    tixian () {
      this.CompanyInfo.visiable = true
      this.CompanyInfo.data.availableBalance = this.availableBalance
    },
    handleUserInfoClose () {
      this.CompanyInfo.visiable = false
    },
    getCancelTixian () {
      this.CompanyInfo.visiable = false
      this.getCompanyWallet()
    },
    // 查询商户纸张数量低于阈值的设备列表，登录后首次打开首页弹窗提醒（阈值以商户配置为准）
    getLowPaperDevices () {
      if (!this.user || this.user.companyCode === '10000') {
        return
      }
      // 登录后仅提醒一次，之后再打开首页不再弹窗（登录成功时清除该标记）
      if (sessionStorage.getItem('LOW_PAPER_NOTIFIED')) {
        return
      }
      this.$get('device/lowPaper').then((r) => {
        let data = r.data.data || {}
        let list = data.devices
        if (data.threshold) {
          this.lowPaperThreshold = data.threshold
        }
        if (list && list.length > 0) {
          this.lowPaperDevices = list
          this.lowPaperVisible = true
          sessionStorage.setItem('LOW_PAPER_NOTIFIED', '1')
        }
      }).catch(() => {
      })
    },
    viewLowPaperDevice (record) {
      this.deviceInfo.data = record
      this.deviceInfo.visiable = true
    },
    handleDeviceInfoClose () {
      this.deviceInfo.visiable = false
    },
  },
  created () {
    this.getRepos()
    this.loadRepo = 1
  },
  mounted () {
    this.welcomeMessage = this.welcome()
    this.getDashboard()
    // 等 DOM 渲染完成后再初始化图表，避免取不到节点导致 echarts.init(null) 报错
    this.$nextTick(() => {
      this.initChart()
    })
    this.runningProject()
    this.updateDateDisplay()
    this.getCompanyWallet()
    this.getLowPaperDevices()
  },
  beforeDestroy () {
    // 销毁图表实例，防止内存泄漏
    if (this.myChart && typeof this.myChart.dispose === 'function') {
      this.myChart.dispose()
    }
    this.myChart = null
  }
}
</script>

<style lang="less">

  .home-page {
    .head-info {
      margin-bottom: .5rem;
      .head-info-card {
        padding: .5rem;
        border-color: #f1f1f1;
        .head-info-avatar {
          display: inline-block;
          float: left;
          margin-right: 1rem;
          img {
            width: 5rem;
            border-radius: 2px;
          }
        }
        .head-info-count {
          display: inline-block;
          float: left;
          .head-info-welcome {
            font-size: 1.05rem;
            margin-bottom: .1rem;
          }
          .head-info-desc {
            color: rgba(0, 0, 0, 0.45);
            font-size: .8rem;
            padding: .2rem 0;
            p {
              margin-bottom: 0;
            }
          }
          .head-info-time {
            color: rgba(0, 0, 0, 0.45);
            font-size: .8rem;
            padding: .2rem 0;
          }
        }
      }
    }
    .count-info {
      .visit-count-wrapper {
        padding-left: 0 !important;
        .visit-count {
          padding: .5rem;
          border-color: #f1f1f1;
          .ant-card-body {
            padding: .5rem 1rem !important;
          }
        }
      }
      .project-wrapper {
        padding-right: 0 !important;
        .project-card {
          border: none !important;
          .ant-card-head {
            border-left: 1px solid #f1f1f1 !important;
            border-top: 1px solid #f1f1f1 !important;
            border-right: 1px solid #f1f1f1 !important;
          }
          .ant-card-body {
            padding: 0 !important;
            table {
              width: 100%;
              td {
                width: 50%;
                border: 1px solid #f1f1f1;
                padding: .6rem;
                .project-avatar-wrapper {
                  display:inline-block;
                  float:left;
                  margin-right:.7rem;
                  .project-avatar {
                    color: #42b983;
                    background-color: #d6f8b8;
                  }
                }
              }
            }
          }
          .project-detail {
            display:inline-block;
            float:left;
            text-align:left;
            width: 78%;
            .project-name {
              font-size:.9rem;
              margin-top:-2px;
              font-weight:600;
            }
            .project-desc {
              color:rgba(0, 0, 0, 0.45);
              p {
                margin-bottom:0;
                font-size:.6rem;
                white-space:nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
    .j_box{
      border-radius: 5px;
      margin-bottom: 10px;
      color:#204A76 ;
      position: relative;
      background-color: #fff;

      p{
        font-size: 24px;

      }
      .iconfont{
        font-size: 28px;
        position: absolute;
        top:10px;
        right:20px;
      }
      .j_number{
        font-size: 42px;
        margin-bottom: 10px;
      }
      .j_ms{
        font-size:20px ;
      }
    }
    .red{color:red ;}
    .green{color: green;}
    .juyeloow{color:#FCA036 ;}
    .j_bule{color:#4AA4FF}
    .ju_anbule{color: #204A76;}
    .dred{color:#FB5694}
    .ju_youLian{
      line-height: 80px;
    background-color: #527BA7;
    padding: 0px 10px;
    font-size: 24px;
    .ju_stitle{
      font-size: 14px;
    }
    .z_siyouNumb{font-size: 24px;font-weight: normal;}
    .z_bgbox{width: 17px;height: 8px;display: inline-block;vertical-align: middle;margin-right: 5px;}
    .ju_bg_yel{background-color: #FFAA4C;}
    .ju_bg_bule{background-color: #32C0CE;}
    .ju_bg_zhishe{background-color: #B6A2DE;}
    .clear:after {
        content: '';
        height: 0;
        line-height: 0;
        display: block;
        visibility: hidden;
        clear: both;
    }
    .clear{zoom: 1;}
    .ju_tu_title{
      width: 100%;

      font-size: 18px;

    }
    .ju_tu_title h2{
        font-size: 30px;
        font-weight: normal;
        margin-bottom: 10px;
      }
     .ju_tu_title ul{width: 80%;margin: 0px auto;}
     .ju_tu_title ul li{
        width: 33.333333%;
        text-align: center;
        float: left;
      }
    }

  }
  .j_box_h{height: 200px;}
@media  screen and (max-width: 1500px){
  .j_box_h{height:120px;}
  .z_h210{height: 250px;}
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue